<script>
  export let touched;
  export let getClass;
  export let value;
</script>

{#if touched}
  <span
    class="uk-position-center-right uk-margin-right {getClass(
      value,
      'uk-text-danger',
      'uk-text-success',
    )}"
    data-uk-icon="icon: {getClass(value, 'warning', 'check')}"
  />
{/if}
